import {contentTypes} from './types';

const content = {
    backgrounds:[
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-1.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-2.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-3.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-4.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-5.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-6.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-7.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-8.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-9.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-10.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-11.webp',
        width:2024,
        height:1080,
        },
        {
        src:'medias/backgrounds/collection-jessula-lena-durr-12.webp',
        width:2023,
        height:1080,
        }
    ],
    scrollables:[
        {
            id:'home',
            width:24287,
            height:1080,
        }
    ],
    intro:{
        title: "La Collection Georges Jessula Deuxième Partie",
        subtitle:"Léna Durr",
        contentTitle: "Titre introduction",
        contentSubtitle: "Sous-titre introduction",
        contentIntro:`<p>Dans ses photographies, vidéos et installations, Léna Durr met en scène sa collection dans ce qu’elle a de plus intime. Accumulations, répétitions, les objets sans valeur qu’elle achète depuis l’enfance ont constitué le corpus de son œuvre jusqu’à ce qu’elle s’intéresse aux collections des autres.</p>`,
        content:`<p>À l’occasion de sa résidence de création, Léna Durr s’est penchée sur la collection d’art africain, constituée à partir des années 1950 par Georges Jessula, donnée au NMNM en 2006 et conservée depuis lors. Elle a souhaité la révéler au public sous la forme d’une frise composée d’archives, d’images artificiellement générées, de photographies et d’entretiens réalisés lors de sa résidence.</p>`,
        ctas:[
            {
            href:"https://www.nmnm.mc",
            title:"Site du Nouveau Musée National de Monaco",
            text:"NMNM",
            target:"_blank",
            },
            {
            href:"https://www.lenadurr.com/",
            title:"Site de Léna Durr",
            text:"Léna Durr",
            target:'_blank',
            }
        ]
    },
    outro:{
        title: "Ce que l’objet dit de lui-même",
        subtitle:"Christine Eyene",
        contentTitle: "Ce que l’objet dit de lui-même",
        contentSubtitle: "Christine Eyene",
        contentIntro:`<p>Il y a quelque temps de cela s’offrait à moi l’occasion de visiter les réserves des collections africaines d’un grand musée national. Placés sur une nappe de papier blanc, des objets soigneusement choisis se laissaient manipuler par les mains expertes de notre hôte, et d’autres, plus humbles, les nôtres, descendantes de celles et ceux à qui ces œuvres avaient, le plus souvent, été enlevées.<br>Ce n’est pas sans appréhension que je m’engageai vers cette rencontre...</p>`,
        content:`<p>Consciente qu’il était fort probable que certaines émotions surgissent au contact de ces œuvres. Si les charmes de guerre aux fins ornements et minutieux détails retinrent mon attention, ce sont toutefois les masques qui, eux, me saisirent plus profondément. Peut-être faut-il y voir quelque chose de l’ordre de l’impact de l’anthropomorphisme, du symbolisme de la figure qui nous regarde, et de ce que l’on y projette d’identité personnelle et collective. </p><p>Mais rien ne pouvait égaler l’émoi de me retrouver seule, pendant un instant, au milieu de ces rayonnages métalliques gris, dans la froideur de ce dispositif destiné à la conservation de nos œuvres, passant du statut de fétiche et curiosité à celui d’œuvre d’art aux dénominations tantôt maladroites, tantôt malaisées. Patrimoine mondial préservé pour notre compte au nom de l’humanité, nous dit-on.<br>Au bas d’une armoire, placée sur un plateau amovible, allongée sur son flanc, une sculpture silencieuse semblait me souffler son douleureux voyage. Tels ces corps qui, du XVIe au XIXe siècle, traversèrent l’Atlantique.</p><p>Aborder une sculpture traditionnelle africaine, en parcourir les détails, sentir son bois parfumé à l’essence du temps, toucher sa surface patinée ne peuvent se défaire de l’interrogation du quand et du comment de la présence de certains objets, ici, hors du territoire qui les a vu naître et les a fait vivre. À l’heure où la question des restitutions est au cœur des débats dans de nombreux pays du Sud ainsi qu’en Occident, comment rendre compte d’une collection qui semblerait s’inscrire dans une autre genèse ? Que signifie de le faire de manière détachée de toute appartenance culturelle, mais sur la base d’une praxis qu’est l’acte de collectionner ? Qu’en est-il de sa restitution numérique, de ses modalités d’accès et de la manière dont celles-ci conditionnent le rapport à l’œuvre ?</p><p>On trouve réponse à certaines de ces questions à la lumière du regard de l’artiste Léna Durr sur les pièces africaines de la collection Georges Jessula, conservée au Nouveau Musée National de Monaco.<br>En 2023, Léna Durr, dont l’approche artistique porte sur la pratique de la collection et de l’accumulation, fut en effet invitée à puiser dans les fonds du NMNM afin d’y choisir l’objet de sa résidence numérique. Son attention se posa alors sur cette collection singulière offerte à la principauté monégasque en 2006, en reconnaissance de la protection que la famille Jessula y avait reçue, à l’abri du nazisme, pendant la Seconde Guerre mondiale. </p><p>Plusieurs points d’ancrage s’offrent alors à l’artiste : les objets, les écrits de Georges Jessula sur sa collection, les archives et témoignages de ses fils, mais aussi sa propre esthétique, apportant occasionnellement son image, voire même, des objets de sa collection. </p><p>Bien que visuellement linéaire, le rendu auquel nous convie Lena Durr se prête à une lecture multiple propice tant à la rupture temporelle qu’à l’anachronie, allant de l’archive authentique au leurre de l’intelligence artificielle. Il s’agit là d’une « impression d’artiste », d’une mise en espace curatée sur une cimaise numérique, d’un récit né de la verticalité du texte, celui de Georges Jessula, de l’onde sonore du récit de ses fils, et du caractère mouvant d’une narration personnelle, parfois subjective, mais toujours ancrée dans une histoire africaine tangible. </p><p>Ainsi l’on apprend qu’en 1945, Georges Jessula arrive à Dakar, alors capitale de l’Afrique-Occidentale française. La ville possède alors le statut particulier de commune, octroyant à ses habitants la citoyenneté française sur un territoire néanmoins soumis à la mainmise coloniale sur ses matières premières, dont l’arachide. C’est donc au Sénégal, dans le cadre de ses fonctions à Senegal Oil, que Georges Jessula rencontre la création artistique africaine. </p><p>Dans son interprétation visuelle, Lena Durr ne manque pas de retracer le cadre économique et social duquel naît l’intérêt de Jessula pour l’art africain. Dès les premières images, l’artiste intègre à sa frise numérique des documents témoignant de ce contexte : carte du Sénégal, pages de passeport, logo de l’huilerie, image du premier chemin de fer dakarois. De même que, très tôt, apparaissent certains objets de la collection : gousse d’arachide en laiton, bracelets en ce même matériau disposés sur les étagères d’une bibliothèque…<br>Une mise en abîme s’opère à la vue du portrait de Mme Jessula flanqué de part et d’autre de ceux de deux diginitaires sénégalais, Ndaté Yalla Mbodj, reine du Walo (à l’ouest du Sénégal) – figure de la résistance anti-coloniale – et son mari. Y fait suite la tête d’un reliquaire kota, originaire du territoire gabonais. La convoitise que l’on sait envers ces objets nous renvoie à la question d’authenticité que nous rappelle l’affiche publicitaire d’un vendeur d’objets d’art africain dénommé Alhadji Traoré. </p><p>Ce document, juxtaposé à la couverture du numéro d’octobre 1977 des Notes africaines de l’Institut fondamental d’Afrique noire, signale l’interaction de Jessula avec une institution ayant marqué la recherche et la culture, au Sénégal et au-delà. Sous les encouragements de l’historien et archéologue Raymond Mauny, alors en poste à l’Institut français d’Afrique noire, le collectionneur devient membre des Amis du musée et soutient à plusieurs occasions l’acquisition d’œuvres, en même temps qu’il augmente sa collection personnelle. Il mentionne trois grandes statues sénoufo, des masques, et un couple de statues pilons du Burkina que l’on retrouve dans la frise. On sait que la collection atteindra quatre cents pièces d’Afrique de l’Ouest et centrale, dont plus d’une centaine est entrée au NMNM.</p><p>L’affiche du Ier Festival mondial des arts nègres (1966), dont l’œuvre graphique est signée de l’artiste sénégalais Ibou Diouf, atteste d’un important événement culturel panafricain dont Georges Jessula fut le témoin. Il se souvient avoir vu « pour la première fois les trésors de l’ancien Nigeria conservés à Londres et à Benin City » et s’étonne que le festival n’ait point généré une flambée de la valeur marchande de ce type d’art. Il note toutefois l’apparition de faux sur le marché.<br>Le rapport entre le vrai et le faux fait naturellement écho au travail de Léna Durr. Il se retrouve dans certaines « mises en scène » de la collection, et dans l’apparence trompeuse d’images « photographiques » résultant de créations à partir d’intelligence artificielle, usant de mots-clés tirés du texte de Jessula.<br>En cela Durr affirme une approche déjà présente dans son œuvre puisque, dans l’appréhension de ses propres collections, la valeur d’un objet ne s’estime pas en numéraire mais en ce que l’artiste y perçoit ou y investit en matière d’esthétique, de symbolique et d’affect. Ce paradigme, voire même paradoxe, n’est pas étranger aux questions d’authentification et d’estimation des œuvres traditionnelles africaines.<br>En effet, au-delà de l’esthétique et de la facture de ces dernières, leur valeur tient à leur charge spirituelle et à leur activation lors de cultes ou de cérémonies – pour celles dont cela en est la fonction. Toutefois, il n’est pas rare que certaines soient destinées à être conservées à l’abri des regards non-initiés, à la mise en terre, ou même à une dégradation naturelle.</p><p>La valeur que leur attribue l’Occident est donc en réalité une notion relative. Nous en voulons pour preuve l’exemple des bracelets en argent mis en gage par les paysans sénégalais lors de la sécheresse, jusqu’à ce que les pluies reviennent et que les récoltes foisonnent. De même que la cargaison de masques mendé remplissant tout un garage déconstruit la notion binaire de vrai/faux. L’abondance peut suggérer le faux tout autant que l’existence du masque, c’est-à-dire sa matérialité, signale le vrai de sa création. Une œuvre ancienne dont l’activation est incertaine serait-elle plus vraie qu’une œuvre plus récente, reprenant des formes anciennes, activée lors de pratiques cultuelles ou mystiques contemporaines ? Une œuvre traditionnelle africaine a-t-elle plus de valeur lorsqu’elle est anonyme, et ne peut être attribuée qu’à une région ou à un peuple, que lorsque l’artiste qui l’a créée est identifiable ? Le premier cas nous ramène bien évidemment à la question de la provenance qui, elle, ne peut être éludée.</p><p>Au fond, l’on pourrait postuler que ce qui importe est ce que l’objet dit de lui-même. Ce qu’il contient de sa propre charge, de sa propre histoire. Ainsi, Léna Durr rejoint la pensée de Georges Jessula lorsqu’il déclare : « On comprendra qu’il y a des faux qui sont, à mes yeux, bien plus précieux que des pièces dignes de la Salle Drouot. »<br>La lecture que Léna Durr nous propose de la collection Georges Jessula ne s’attache ni à user d’un didactisme ethnographique, ni à feindre une expertise des arts africains. Elle met en exergue de multiples points d’entrée qui nous invitent à appréhender la complexité de la genèse d’une collection privée et à en saisir la portée discursive dès lors qu’elle intègre une collection nationale.</p>`,
    },
    modals:[
        {
            id:1,
            scrollableId:'home',
            type:'gallery',
            width:"small",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Senegal Oil",
                medias:[
                    {src:'medias/01/01.webp',
                    alt:'Album photo chez Daniel à Paris, 2023, Léna Durr ©',
                    figcaption:'Album photo chez Daniel à Paris, 2023, Léna Durr ©'},
                    {src:'medias/01/02.webp',
                    alt:'Album photo chez Daniel à Paris, 2023, Léna Durr ©',
                    figcaption:'Album photo chez Daniel à Paris, 2023, Léna Durr ©'},
                    {src:'medias/01/03.webp',
                    alt:'Album photo chez Daniel à Paris, 2023, Léna Durr ©',
                    figcaption:'Album photo chez Daniel à Paris, 2023, Léna Durr ©'},
                    {src:'medias/01/04.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/01/05.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/01/06.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/01/07.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/01/08.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/01/09.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                ],
                audio:{
                    src:'medias/01/01.mp4',
                    play:true,
                    loop:false,
                }
            },
            button:{
                'left':0,
                'top':64,
                'width':2.55,
                'height':36,
            },
        },
        {
            id:2,
            scrollableId:'home',
            type:'gallery',
            width:"small",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Senegal Oil 2",
                medias:[
                    {src:'medias/02/01.webp',
                    alt:'Chez Daniel à Paris, 2023, Léna Durr ©',
                    figcaption:'Chez Daniel à Paris, 2023, Léna Durr ©'},
                    {src:'medias/02/02.webp',
                    alt:'Affiche Sénégaloil, document internet',
                    figcaption:'Affiche Sénégaloil, document internet'},
                ],
            },
            button:{
                'left':2.99,
                'top':44.9,
                'width':.53,
                'height':15,
                'zIndex':50,
            },
        },
        {
            id:4,
            scrollableId:'home',
            type:'gallery',
            width:"small",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Passeport Jessula",
                medias:[
                    {src:'medias/04/01.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/04/02.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/04/03.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                ],
            },
            button:{
               'left':1.98,
                'top':13.2,
                'width':0.71,
                'height':21.2,
            },
        },
        {
            id:5,
            scrollableId:'home',
            type:'zoom',
            width:"medium",
            fullscreen:true,
            content:{
                title:"Bracelet Paris",
                medias:[
                    {
                        src:'medias/05/01.webp',
                        alt:'Arrière boutique, 2023, Léna Durr ©',
                        width:1072,
                        height:1500,
                        zoomScale:1.3,
                    },
                    {
                        src:'medias/05/02.webp',
                        alt:'Arrière boutique, 2023, Léna Durr ©',
                        width:1071,
                        height:1500,
                        zoomScale:1.3,
                    }
                ],
                modalFigcaption:'Arrière boutique, 2023, Léna Durr ©'
            },
            button:{
                'left':3.99,
                'top':0,
                'width':2.81,
                'height':42,
            },
        },
        {
            id:6,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:true,
                speed:4000,
                delay:4000,
                title:"Lunel à Dakar",
                medias:[
                    {src:'medias/06/01.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/06/02.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/06/03.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/06/04.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                ],
            },
            button:{
                'left':7.15,
                'top':5,
                'width':2.7,
                'height':78.5,
            },
        },
        {
            id:7,
            scrollableId:'home',
            type:'iframe',
            width:"large",
            content:{
                link:'https://www.google.com/maps/embed?pb=!3m2!1sfr!2sfr!4v1725919838518!5m2!1sfr!2sfr!6m8!1m7!1sCAoSLEFGMVFpcE9jbFZBVzlrc1Jjdm1nVjVOdGVNNXNERlRoc3JZWlAwNlZDcUxr!2m2!1d43.4955635!2d6.9426355!3f3.86!4f5.239999999999995!5f0.7820865974627469',
                title:'Vierge noire',
                modalFigcaption:'Mémorial Notre Dame d’Afrique, Théoules-sur-Mer, Martin Gygax ©',
            },
            button:{
                'left':9.44,
                'top':2.5,
                'width':.55,
                'height':67.5,
                'zIndex':50,
            },
        },
        {
            id:8,
            scrollableId:'home',
            type:'image',
            width:"small",
            content:{
                title:"Voiture de Georges",
                image:{
                    src:'medias/08/01.webp',
                    alt:'Grande et confortable auto Américaine, photographie générée par une intelligence artificielle, 2023, Léna Durr ©',
                },
                modalFigcaption:'Grande et confortable auto Américaine, photographie générée par une intelligence artificielle, 2023, Léna Durr ©'
            },
            button:{
                'left':8.35,
                'top':71.5,
                'width':1.68,
                'height':26.6,
                'zIndex':50,
            },
        },
        {
            id:9,
            scrollableId:'home',
            type:'zoom',
            width:"medium",
            fullscreen:true,
            content:{
                title:"Épouse Lunel",
                medias:[
                    {
                        src:'medias/09/01.webp',
                        alt:"[…] à part Derain et Picasso, Paul Guillaume et une poignée de collectionneurs, personne ne s’intéressait à l’art nègre., 2023, Léna Durr ©",
                        width:1071,
                        height:1500,
                        zoomScale:1.3,
                    },
                ],
                modalFigcaption:"[…] à part Derain et Picasso, Paul Guillaume et une poignée de collectionneurs, personne ne s’intéressait à l’art nègre., 2023, Léna Durr ©",
                audio:{
                    src:'medias/09/01.mp4',
                    play:true,
                    loop:false,
                }
            },
            button:{
                'left':10.12,
                'top':0,
                'width':2.97,
                'height':100,
            },
        },
        {
            id:10,
            scrollableId:'home',
            type:'gallery',
            width:"small",
            animatedButton:{
                image:{
                    src:'medias/10/button.webp',
                    alt:'Reliquaire',
                },
                width:.77,
                height:40,
                top:60,
                animation:"up",
                speed:.3
            },
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Reliquaire",
                medias:[
                    {src:'medias/10/01.webp',
                    alt:'Portrait de Paul Guillaume, par Kees van Dongen, 1930, image internet',
                    figcaption:'Portrait de Paul Guillaume, par Kees van Dongen, 1930, image internet'},
                    {src:'medias/10/02.webp',
                    alt:'Portrait de Paul Guillaume, par Giorgio De Chirico, 1915, image internet',
                    figcaption:'Portrait de Paul Guillaume, par Giorgio De Chirico, 1915, image internet'},
                    {src:'medias/10/03.webp',
                    alt:'Portrait de Paul Guillaume, par Giorgio De Chirico, 1915 (2), image internet',
                    figcaption:'Portrait de Paul Guillaume, par Giorgio De Chirico, 1915 (2), image internet'},
                    {src:'medias/10/04.webp',
                    alt:'Portrait de Paul Guillaume, par André Derain, 1919, image internet',
                    figcaption:'Portrait de Paul Guillaume, par André Derain, 1919, image internet'},
                    {src:'medias/10/05.webp',
                    alt:'Portrait de Paul Guillaume, par Amedeo Modigliani, 1916, image internet',
                    figcaption:'Portrait de Paul Guillaume, par Amedeo Modigliani, 1916, image internet'},
                    {src:'medias/10/06.webp',
                    alt:'Portrait de Paul Guillaume, par Amedeo Modigliani, 1915, image internet',
                    figcaption:'Portrait de Paul Guillaume, par Amedeo Modigliani, 1915, image internet'},
                    {src:'medias/10/07.webp',
                    alt:'Portrait de Paul Guillaume, par Amedeo Modigliani, 1915 (2), image internet',
                    figcaption:'Portrait de Paul Guillaume, par Amedeo Modigliani, 1915 (2), image internet'},
                ]
            },
            button:{
                'left':12.45,
                'top':84.9,
                'width':.77,
                'height':15.1,
                'zIndex':50,
            },
        },
        {
            id:11,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Villa Dakar",
                medias:[
                    {src:'medias/11/01.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/11/02.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                ]
            },
            button:{
                'left':13.09,
                'top':0,
                'width':4.53,
                'height':100,
            },
        },
        {
            id:13,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Marchand d'art",
                medias:[
                    {src:'medias/13/01.webp',
                    alt:'La collection chez Daniel à Paris, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Paris, Léna Durr ©'},
                    {src:'medias/13/02.webp',
                    alt:'La collection chez Daniel à Paris, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Paris, Léna Durr ©'},
                    {src:'medias/13/03.webp',
                    alt:'La collection chez Daniel à Paris, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Paris, Léna Durr ©'},
                    {src:'medias/13/04.webp',
                    alt:'La collection chez Daniel à Paris, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Paris, Léna Durr ©'},
                    {src:'medias/13/05.webp',
                    alt:'La collection chez Daniel à Monaco, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Monaco, Léna Durr ©'},
                    {src:'medias/13/06.webp',
                    alt:'La collection chez Daniel à Monaco, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Monaco, Léna Durr ©'},
                    {src:'medias/13/07.webp',
                    alt:'La collection chez Daniel à Monaco, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Monaco, Léna Durr ©'},
                    {src:'medias/13/08.webp',
                    alt:'La collection chez Daniel à Monaco, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Monaco, Léna Durr ©'},
                ]
            },
            button:{
                'left':17.75,
                'top':42,
                'width':1.92,
                'height':55.6,
                'zIndex':50,
            },
        },
        {
            id:14,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Ifan",
                medias:[
                    {src:'medias/14/01.webp',
                    alt:'Théodore Monod, image internet',
                    figcaption:'Théodore Monod, image internet'},
                    {src:'medias/14/02.webp',
                    alt:'Théodore Monod, image internet',
                    figcaption:'Théodore Monod, image internet'},
                    {src:'medias/14/03.webp',
                    alt:'Théodore Monod, image internet',
                    figcaption:'Théodore Monod, image internet'},
                    {src:'medias/14/04.webp',
                    alt:'Théodore Monod, image internet',
                    figcaption:'Théodore Monod, image internet'},
                    {src:'medias/14/05.webp',
                    alt:'Raymond Mauny',
                    figcaption:'Raymond Mauny'},
                    {src:'medias/14/06.webp',
                    alt:'Archaeologist /historian Raymond Mauny in a field of corn in Sénégal 1967, image internet',
                    figcaption:'Archaeologist /historian Raymond Mauny in a field of corn in Sénégal 1967, image internet'},
                    {src:'medias/14/07.webp',
                    alt:'Le Sénégal A. Lunel, Léna Durr ©',
                    figcaption:'Le Sénégal A. Lunel, Léna Durr ©'},
                ]
            },
            button:{
                'left':19.42,
                'top':3.4,
                'width':3.23,
                'height':91,
            },
        },
        {
            id:15,
            scrollableId:'home',
            type:'zoom',
            width:"small",
            content:{
                title:"Masques garage",
                medias:[
                    {
                        src:'medias/15/01.webp',
                        alt:"J'en ai acheté trop peu, 2023, Léna Durr ©",
                        width:772,
                        height:1080,
                        zoomScale:1.3,
                    }
                ],
                modalFigcaption:"J'en ai acheté trop peu, 2023, Léna Durr ©"
            },
            button:{
                'left':22.55,
                'top':0,
                'width':3.18,
                'height':100,
            },
        },
        {
            id:16,
            scrollableId:'home',
            type:'zoom',
            width:"fullscreen",
            animatedButton:{
                image:{
                    src:'medias/16/button.webp',
                    alt:'Appropriation culturelle, 2023, Léna Durr ©',
                },
                width:1.38,
                height:50,
                top:0,
                animation:"down",
                speed:.3,
            },
            content:{
                title:"Exportation",
                medias:[
                    {
                        src:'medias/16/01.webp',
                        alt:'Appropriation culturelle, 2023, Léna Durr ©',
                        width:2500,
                        height:1766,
                        zoomScale:1.3,
                    },
                    {
                        src:'medias/16/02.webp',
                        alt:'Appropriation culturelle, 2023, Léna Durr ©',
                        width:2500,
                        height:1766,
                        zoomScale:1.3,
                    },
                    {
                        src:'medias/16/03.webp',
                        alt:'Appropriation culturelle, 2023, Léna Durr ©',
                        width:2500,
                        height:1766,
                        zoomScale:1.3,
                    }
                ],
                 modalFigcaption:'Appropriation culturelle, 2023, Léna Durr ©'
            },
            button:{
                left:24.55,
                top:0,
                width:1.38,
                height:25.35,
            },
        },
        {
            id:17,
            scrollableId:'home',
            type:'image',
            width:"small",
            content:{
                title:"Couple Pilon",
                image:{
                    src:'medias/17/01.webp',
                    alt:'La collection chez Daniel à Monaco, 2023, Léna Durr ©',
                },
                modalFigcaption:'La collection chez Daniel à Monaco, 2023, Léna Durr ©'
            },
            button:{
                'left':25.73,
                'top':0,
                'width':2.97,
                'height':100,
            },
        },
        {
            id:18,
            scrollableId:'home',
            type:'zoom',
            width:"large",
            content:{
                title:"Hache",
                medias:[
                    {
                        src:'medias/18/01.webp',
                        alt:'[…] ce sont des objets de cultes, parfois redoutables, pour lesquels il vaudrait mieux le secret […], 2023, Léna Durr ©',
                        width:2000,
                        height:1429,
                        zoomScale:1.3,
                    }
                ],
                 modalFigcaption:'[…] ce sont des objets de cultes, parfois redoutables, pour lesquels il vaudrait mieux le secret […], 2023, Léna Durr ©'
            },
            button:{
                'left':28.87,
                'top':3.2,
                'width':4.46,
                'height':71.7,
            },
        },
        {
            id:20,
            scrollableId:'home',
            type:'image',
            width:"small",
            content:{
                title:"Thiam",
                modalFigcaption:"Tiam Bodiène, photographie générée par une intelligence artificielle, 2023, Léna Durr ©",
                image:{
                    src:'medias/20/01.webp',
                }
            },
            button:{
                'left':33.5,
                'top':0,
                'width':3.56,
                'height':100,
            },
        },
        {
            id:21,
            scrollableId:'home',
            type:'iframe',
            width:"medium",
            content:{
                link:'https://www.google.com/maps/embed?pb=!3m2!1sfr!2sfr!4v1725921155099!5m2!1sfr!2sfr!6m8!1m7!1sCAoSLEFGMVFpcFB6akhhVmNKaEI0VDVaV1FfcXZrR0ZUTF9yel85VHRnU1pPdTJF!2m2!1d5.300638034070723!2d-3.995144153663427!3f185.43!4f30.620000000000005!5f0.7820865974627469',
                title:'Solibra',
                modalFigcaption:'Street view Usine SOLIBRA',
            },
            button:{
                'left':37.06,
                'top':0,
                'width':3.09,
                'height':16.9,
                'zIndex':50,
            },
        },
        {
            id:23,
            scrollableId:'home',
            type:'gallery',
            width:"small",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Faux",
                medias:[
                    {src:'medias/23/01.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/23/02.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                ]
            },
            button:{
                'left':36.83,
                'top':42.2,
                'width':3.4,
                'height':51.9,
            },
        },
        {
            id:24,
            scrollableId:'home',
            type:'gallery',
            width:"large",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Georges Abidjan",
                medias:[
                    {src:'medias/24/01.webp',
                    alt:'La collection chez Daniel à Paris, 2023, Léna Durr ©',
                    figcaption:'La collection chez Daniel à Paris, 2023, Léna Durr ©'},
                    {src:'medias/24/02.webp',
                    alt:'document internet',
                    figcaption:'document internet'},
                ]
            },
            button:{
                'left':40.28,
                'top':3.7,
                'width':2.84,
                'height':89.5,
            },
        },
        {
            id:25,
            scrollableId:'home',
            type:'zoom',
            width:"small",
            content:{
                title:"Caisse bière",
                medias:[
                    {
                        src:'medias/25/01.webp',
                        alt:'La caisse Gaschet, 2023, Léna Durr ©',
                        width:1071,
                        height:1500,
                        zoomScale:1.3,
                    },
                ],
                audio:{
                    src:'medias/25/01.mp4',
                    play:true,
                    loop:false,
                },
                modalFigcaption:'La caisse Gaschet, 2023, Léna Durr ©'
            },
            button:{
                'left':43.66,
                'top':9.2,
                'width':1.74,
                'height':29.4,
            },
        },
        {
            id:26,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Statuette étrange",
                medias:[
                    {src:'medias/26/01.webp',
                    alt:'Josette Rivallain, document internet',
                    figcaption:'Josette Rivallain, document internet'},
                    {src:'medias/26/02.webp',
                    alt:'document internet',
                    figcaption:'document internet'},
                    {src:'medias/26/03.webp',
                    alt:'document internet',
                    figcaption:'document internet'},
                ],
            },
            button:{
                'left':44.53,
                'top':43.8,
                'width':1.45,
                'height':45.5,
            },
        },
        {
            id:27,
            scrollableId:'home',
            type:'zoom',
            width:"medium",
            content:{
                title:"Forêt poids",
                medias:[
                    {
                        src:'medias/27/01.webp',
                        alt:"Ceux-la viennent de la fôret, 2023, Léna Durr ©",
                        width:2000,
                        height:1429,
                        zoomScale:1.3,
                    },
                ],
                modalFigcaption:'Ceux-la viennent de la fôret, 2023, Léna Durr ©',
            },
            button:{
                'left':46.4,
                'top':0,
                'width':6.23,
                'height':100,
            },
        },
        {
            id:28,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Masque Paris",
                medias:[
                    {src:'medias/28/01.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                    {src:'medias/28/02.webp',
                    alt:'Archives de la Famille Jessula',
                    figcaption:'Archives de la Famille Jessula'},
                ],
            },
            button:{
                'left':52.63,
                'top':0,
                'width':2.97,
                'height':100,
            },
        },
        {
            id:30,
            scrollableId:'home',
            type:'zoom',
            width:"small",
            content:{
                title:"Baya",
                medias:[
                    {
                        src:'medias/30/01.webp',
                        alt:'Les Trois Grâces, 2023, Léna Durr ©',
                        width:771,
                        height:1080,
                        zoomScale:1.3,
                    },
                ],
                modalFigcaption:"Les Trois Grâces, 2023, Léna Durr ©"
            },
            button:{
                'left':55.87,
                'top':56.7,
                'width':2.19,
                'height':39.2,
            },
        },
        /*{
            id:31,
            scrollableId:'home',
            type:'image',
            fullscreen:true,
            width:"medium",
            content:{
                title:"Toubab",
                image:{src:'medias/31/01.webp'},
            },
            button:{
                'left':58.3,
                'top':4.1,
                'width':1.18,
                'height':49.2,
                'zIndex':50,
            },
        },*/
        {
            id:32,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:false,
                loop:false,
                speed:500,
                delay:4000,
                title:"Théière",
                modalFigcaption:"Collection Léna Durr, objets ramenés du Sénégal en 2013, Léna Durr ©",
                medias:[
                    {src:'medias/32/01.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/02.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/03.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/04.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/05.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/06.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/07.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/08.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                    {src:'medias/32/09.webp',
                    alt:'Collection, objets ramenés du Sénégal en 2013, Léna Durr ©',
                    },
                ]
            },
            button:{
                'left':57.87,
                'top':39,
                'width':1.33,
                'height':31.8,
                'zIndex':60,
            },
        },
        {
            id:33,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Porte Dogon",
                medias:[
                    {src:'medias/33/01.webp',
                    alt:'Hôtel Ivoire, Abidjan, document internet',
                    figcaption:'Hôtel Ivoire, Abidjan, document internet'},
                    {src:'medias/33/02.webp',
                    alt:'Timbre de l’hôtel Ivoire, Abidjan, document internet',
                    figcaption:'Timbre de l’hôtel Ivoire, Abidjan, document internet'},
                    {src:'medias/33/03.webp',
                    alt:'Hôtel Ivoire, Abidjan, document internet',
                    figcaption:'Hôtel Ivoire, Abidjan, document internet'},
                    {src:"https://www.google.com/maps/embed?pb=!4v1736943491223!6m8!1m7!1sCAoSK0FGMVFpcE51bExZMWZCRW1yclRlaDRuSGlrYlNCZTJiMjV3Zk15alktc3c.!2m2!1d5.327115801136234!2d-4.006268393871293!3f329.19!4f33.36!5f0.7820865974627469",
                    alt:'Hotel Ivoire, Abidjan, Ebick Ngoma ©',
                    figcaption:'Hotel Ivoire, Abidjan, Ebick Ngoma ©',
                    template:'iframe',
                    },
                ],
            },
            button:{
                'left':59,
                'top':0,
                'width':3,
                'height':100,
            },
        },
        {
            id:34,
            scrollableId:'home',
            type:'video',
            width:"medium",
            content:{
                title:"Tapis",
                video:{
                    src:'medias/34/01.mp4',
                    alt:'Cléopâtre, 2023, Léna Durr ©',
                    hideControls:true
                    },
                modalFigcaption:"Cléopâtre, 2023, Léna Durr ©"
            },
            button:{
                'left':62.09,
                'top':2.9,
                'width':3.82,
                'height':61.1,
            },
        },
        {
            id:35,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Drouot",
                medias:[
                    {
                        src:"medias/35/01.webp",
                        alt:"La troisième table, 2023, Léna Durr ©",
                        figcaption:"La troisième table, 2023, Léna Durr ©",
                        template:"zoom",
                        width:"2000",
                        height:"1428",
                    },
                    {
                        src:"medias/35/02.webp",
                        alt:"Drouot, Paris, 2023, Léna Durr ©",
                        figcaption:"Drouot, Paris, 2023, Léna Durr ©",
                    },
                ],
            },
            button:{
                'left':65.09,
                'top':37.5,
                'width':1.9,
                'height':62.5,
                'zIndex':50,
            },
        },
        {
            id:36,
            scrollableId:'home',
            type:'zoom',
            width:"medium",
            content:{
                title:"Bureau",
                medias:[
                    {
                        src:'medias/36/01.webp',
                        alt:"À Monaco ce sont des presse-papiers très commodes., 2023, Léna Durr ©",
                        width:1512,
                        height:1080,
                        zoomScale:1.3,
                    },
                ],
                modalFigcaption:"À Monaco ce sont des presse-papiers très commodes., 2023, Léna Durr ©",
            },
            button:{
                'left':67.04,
                'top':0,
                'width':6.23,
                'height':100,
            },
        },
        {
            id:38,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:true,
                loop:false,
                speed:500,
                delay:4000,
                title:"Robinet bronze",
                medias:[
                    {
                        src:"medias/38/01.webp",
                        alt:"Archives de la famille Jessula",
                        figcaption:"Archives de la famille Jessula",
                    },
                    {
                        src:"medias/38/02.webp",
                        alt:"La collection chez Daniel à Monaco, 2023, Léna Durr ©",
                        figcaption:"La collection chez Daniel à Monaco, 2023, Léna Durr ©",
                    },
                    {
                        src:"medias/38/03.webp",
                        alt:"La collection chez Daniel à Paris, 2023, Léna Durr ©",
                        figcaption:"La collection chez Daniel à Paris, 2023, Léna Durr ©",
                    },
                ],
            },
            button:{
                'left':75.97,
                'top':44,
                'width':1.84,
                'height':28.7,
                'zIndex':50,
            },
        },
        {
            id:39,
            scrollableId:'home',
            type:'video',
            width:"medium",
            content:{
                title:"Album photos",
                video:{
                    src:'medias/39/01.mp4',
                    alt:'Archives de la Famille Jessula',
                    hideControls:true
                },
                modalFigcaption:"Archives de la Famille Jessula",
            },
            button:{
                'left':76.4,
                'top':0,
                'width':3.41,
                'height':54.7,
            },
        },
        {
            id:40,
            scrollableId:'home',
            type:'image',
            width:"small",
            content:{
                title:"Cheval bronze",
                image:{
                    src:'medias/40/01.webp',
                    alt:"Document internet",
                },
                modalFigcaption:"Document internet",
            },
            button:{
                'left':77.955,
                'top':34.1,
                'width':2.1,
                'height':65.9,
                'zIndex':50,
            },
        },
        {
            id:41,
            scrollableId:'home',
            type:'gallery',
            width:"medium",
            content:{
                play:false,
                loop:false,
                speed:500,
                title:"Inventaire papier",
                modalFigcaption:"Archives de la Famille Jessula",
                medias:[
                    {
                        src:"medias/41/01.webp",
                    },
                    {
                        src:"medias/41/02.webp",
                    },
                    {
                        src:"medias/41/03.webp",
                    },
                    {
                        src:"medias/41/04.webp",
                    },
                    {
                        src:"medias/41/05.webp",
                    },
                    {
                        src:"medias/41/06.webp",
                    },
                    {
                        src:"medias/41/07.webp",
                    },
                    {
                        src:"medias/41/08.webp",
                    },
                    {
                        src:"medias/41/09.webp",
                    },
                    {
                        src:"medias/41/10.webp",
                    },
                    {
                        src:"medias/41/11.webp",
                    },
                    {
                        src:"medias/41/12.webp",
                    },
                ],
            },
            button:{
                'left':80.2,
                'top':16.5,
                'width':2.13,
                'height':62.8,
                'zIndex':50,
            },
        },
        {
            id:42,
            scrollableId:'home',
            type:'video',
            width:"medium",
            content:{
                title:"Inventaire photos",
                video:{
                    src:"medias/42/01.mp4",
                    alt:"Archives de la Famille Jessula",
                    hideControls:true
                },
                modalFigcaption:"Archives de la Famille Jessula",
            },
            button:{
                'left':80.42,
                'top':53.5,
                'width':0.41,
                'height':33.4,
                'zIndex':60,
            },
        },
        {
            id:43,
            scrollableId:'home',
            type:'zoom',
            width:"medium",
            content:{
                title:"Frères Jessula",
                medias:[
                    {
                        src:'medias/43/01.webp',
                        alt:"Archives de la Famille Jessula",
                        width:1500,
                        height:1071,
                        zoomScale:1.3,
                    },
                ],
                modalFigcaption:"Archives de la Famille Jessula",
            },
            button:{
                'left':81.9,
                'top':0,
                'width':5.57,
                'height':100,
            },
        },
        {
            id:44,
            scrollableId:'home',
            type:'image',
            content:{
                title:"Masque caché",
                image:{
                    src:'medias/44/01.webp',
                    alt:"La collection chez Daniel à Paris, 2023, Léna Durr ©",
                },
                modalFigcaption:"La collection chez Daniel à Paris, 2023, Léna Durr ©",
            },
            button:{
                'left':87.63,
                'top':11.7,
                'width':1.55,
                'height':49,
                'zIndex':50,
            },
        },
         /*{
            id:3,
            scrollableId:'home',
            type:'image',
            fullscreen:true,
            content:{
                title:"Chemin de fer",
                image:{
                    src:'medias/03/01.webp',
                    alt:'',
                    figcaption:''
                },
            },
            button:{
                'left':2.83,
                'top':42,
                'width':4.11,
                'height':58,
            },
        },*/
        /*{
            id:12,
            scrollableId:'home',
            type:'image',
            fullscreen:true,
            content:{
                title:"Collection huile",
                image:{
                    src:'medias/12/01.webp',
                },
            },
            button:{
                'left':16.98,
                'top':0,
                'width':2.35,
                'height':39.7,
                'zIndex':50,
            },
        },*/
         /*{
            id:19,
            scrollableId:'home',
            type:'zoom',
            fullscreen:true,
            content:{
                title:"Senhgor Quai Branly",
                medias:[
                    {
                        src:'medias/19/01.webp',
                        width:1429,
                        height:2000,
                        zoomScale:1.3,
                    }
                ],
            },
            button:{
                'left':28.87,
                'top':56.6,
                'width':1.18,
                'height':38,
                'zIndex':50,
            },
        },*/
         /*{
            id:22,
            scrollableId:'home',
            type:'image',
            content:{
                title:"Statuette Clou",
                image:{src:'medias/22/02.webp'}
            },
            button:{
                'left':38.85,
                'top':22.4,
                'width':0.97,
                'height':39.6,
                'zIndex':50,
            },
        },*/
          /*{
            id:29,
            scrollableId:'home',
            type:'image',
            width:"medium",
            content:{
                title:"Collier or",
                image:{src:'medias/29/01.webp'}
            },
            button:{
                'left':55.87,
                'top':4.1,
                'width':2.19,
                'height':49.2,
            },
        },*/
        /*{
            id:37,
            scrollableId:'home',
            type:'image',
            fullscreen:true,
            content:{
                title:"Mosquet Biourbel",
                image:{
                    src:'medias/37/01.webp',
                },
            },
            button:{
                'left':73.42,
                'top':6.1,
                'width':2.68,
                'height':84.8,
            },
        },*/
        /*{
            id:45,
            scrollableId:'home',
            type:'image',
            fullscreen:true,
            content:{
                title:"Album fermé",
                image:{
                    src:'medias/45/01.webp',
                },
            },
            button:{
                'left':87.88,
                'top':0,
                'width':12.12,
                'height':100,
            },
        },*/
    ]
}

content.propTypes  = contentTypes;

export default content;